import React, { Suspense, useMemo, useState } from 'react';
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import InmobiliariaForm, { InmobiliariaWriteDto } from '../../../../features/maestros/inmobiliarias/components/inmobiliariaForm';
import { exportExcel } from '../../../../utils/exportExcel';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import FloatingButton from '../../../../components/ui/materialui/floatingButton';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { Box, Paper } from '@mui/material';
import { useColumns } from '../utils/columns';
import { config } from '../../../../utils/config';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';


function Inmobiliarias() {

  const [isLoading, setIsLoading] = React.useState(false)
  const [refresh, setRefresh] = useState(false)
  const [modalDetalle, setModalDetalle] = useState(false)
  const [inmobiliariaEditar, setInmobiliariaEditar] = useState<InmobiliariaWriteDto>()

  const urlTabla = `siscred-api-maestros/v1/inmobiliarias/listar`;

  const control = useDataFetch(
    urlTabla,
    new URLSearchParams('filters.status=ACTIVA'),
    true,
  )

  const { COLUMNS } = useColumns({ control, setInmobiliariaEditar, setModalDetalle });
  const columns = useMemo(() => COLUMNS, [control]);

  const breadcrumbItems = [
    { label: 'Inicio', url: '/' },
    { label: 'Maestros', url: `/maestros` },
    { label: 'Inmobiliarias', active: true },
  ]

  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {
    },
  })

  return (
    <>
      <Suspense>
        <ConfirmationModal
          onHide={() =>
            setModalConfirmacion({
              ...modalConfirmacion,
              show: false,
            })
          }
          onConfirm={modalConfirmacion.metodo}
          show={modalConfirmacion.show}
          title={modalConfirmacion.title}
          message={modalConfirmacion.message}
        />

        <InmobiliariaForm show={modalDetalle} dataediting={inmobiliariaEditar} onHide={() => setModalDetalle(false)}
          refresh={() => control.fetchData()} 
          convenios={[
            { value: '1', label: 'Convenio A', title: 'Pago contra firma de inmobiliaria' },
            { value: '2', label: 'Convenio B', title: 'Pago al segundo día desde que firma el banco alzante' },
            { value: '3', label: 'Convenio C', title: 'Pago a firma MetLife' },
            { value: '4', label: 'Convenio D', title: 'Pago al quinto día de inscripción en CBR' },
            { value: '5', label: 'Convenio E', title: 'Pago posterior a la salida del CBR' }
          ]}></InmobiliariaForm>

        <Breadcrumb items={breadcrumbItems} />

        <Box sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Suspense>
              <Tabla
                columns={columns}
                control={control}
                url={urlTabla}
                titulo={<TableHeader
                  title=""
                  control={control}
                  button={
                    <>
                    <PermissionGuard permissions={[TipoFuncionalidad.Maestros_editar]}>
                      <MButton variant="contained" startIcon={<AddTwoToneIcon />}
                        onClick={() => { setModalDetalle(true); setInmobiliariaEditar(undefined) }}>Nueva</MButton>
                    </PermissionGuard>
                    </>
                  }
                  buttonExport={
                    <>
                    <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                      <MButton variant="outlined" startIcon={<SummarizeTwoToneIcon />}
                        onClick={() => exportExcel(control.data, columns, 'INMOBILIARIA')}>

                        Exportar</MButton>
                    </PermissionGuard>
                    </>
                  }
                />}
              />
            </Suspense>
          </Paper>
        </Box>
      </Suspense>
    </>
  );
}

export default Inmobiliarias;
